var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.8333 21.0833L27.5 26.75M2 12.5833C2 15.5891 3.19404 18.4718 5.31946 20.5972C7.44487 22.7226 10.3275 23.9167 13.3333 23.9167C16.3391 23.9167 19.2218 22.7226 21.3472 20.5972C23.4726 18.4718 24.6667 15.5891 24.6667 12.5833C24.6667 9.57755 23.4726 6.69487 21.3472 4.56946C19.2218 2.44404 16.3391 1.25 13.3333 1.25C10.3275 1.25 7.44487 2.44404 5.31946 4.56946C3.19404 6.69487 2 9.57755 2 12.5833Z",
    stroke: "white",
    strokeWidth: 2.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c01910bbcddd39ea8005908472c7dde3.svg";
export { ForwardRef as ReactComponent };